import React from "react"
import Label from "../atoms/Label.atom"
import UnifiedDatePicker from "../compounds/UnifiedDatePicker.compound"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import { hasAnyErrors } from "../../utils/validations.utils"
import { clsx } from "../../utils/strings.utils"

const UnifiedDatePickerForm = React.forwardRef((props, ref) => {
  const forId =
    props.id ||
    `unified-datepicker-${props.label?.replace(/ /g, "-")}-${new Date().getTime()}`
  return (
    <>
      {props.label && (
        <Label className={clsx(props.disabled && "p-disabled")} htmlFor={forId}>
          {props.label}
          {props.require ? " *" : ""}
          {props.optional ? " (opcional)" : ""}
        </Label>
      )}{" "}
      <UnifiedDatePicker
        ref={ref}
        calendarInputId={forId}
        hasSingleWeek={props.hasSingleWeek}
        hasSingleMonth={props.hasSingleMonth}
        hasDayPeriod={props.hasDayPeriod}
        hidePeriodSelector={props.hidePeriodSelector}
        hideChevron={props.hideChevron}
        dateRange={props.dateRange}
        setDateRange={props.setDateRange}
        period={props.period}
        format={props.format}
        datePickerProps={props.datePickerProps}
        className={clsx(
          hasAnyErrors(props.error) && "p-invalid",
          props.className
        )}
        disabled={props.disabled}
      />
      {hasAnyErrors(props.error) ?
        <ErrorMessageForm errorMessage={props.error[0]?.errorMessage} />
      : null}
    </>
  )
})

export default UnifiedDatePickerForm
